import React from 'react';
import { IBottomSearchboxProps } from '../searchresultpage.d';
import * as helper from '../../../Common/html-helper';
import classNames from 'classnames';
import FragmentPlaceholder from '../../../Common/fragment-placeholder/fragment-placeholder';
import styles from './searchbox.scss';

const BottomSearchbox = (props: IBottomSearchboxProps) => {
    return (
        <div className={classNames(styles.search_box_fragment, styles.bottom, props.style)}>
            <hr className={styles.border} />
            <div className={styles.headline}>
                {helper.decodeHTML(props.l10n.stillDidntFindTheRightOne)}
            </div>

            <FragmentPlaceholder
                src={'ESPP2.ShopSearch.Web/searchbox/search-grid'}
                ignoreErrors={true}
                fallbackSrc={'/darkmatter-fallbacks/ESPP2.ShopSearch.Web/ssw-fallback-search-grid.html'}
            />
        </div>
    );
};

export default BottomSearchbox;